import { LayoutDashboard, ShieldCheck } from 'lucide-react';

import { agentsModule } from '@/app/core/app/agents/agents.module';
import { conversationsModule } from '@/app/core/app/conversations-v2/conversations.module';
import { metaAdsModule } from '@/app/core/app/meta-ads/meta-ads.module';
import { thunkGetOrganization } from '@/app/core/app/organization/domain/state/organizationThunks';
import { productsModule } from '@/app/core/app/products/products.module';
import { apiKeysModule } from '@/app/core/app/settings/api-keys/api-keys.module';
import { apiUsageModule } from '@/app/core/app/settings/api-usage/api-usage.module';
import { customDomainsModule } from '@/app/core/app/settings/custom-domains/custom-domains.module';
import { billingModule } from '@/app/core/app/settings/billing/billing.module';
import { integrationsModule } from '@/app/core/app/settings/integrations/integrations.module';
import { whatsappGroupsModule } from '@/app/core/app/whatsapp-groups/whatsapp-groups.module';
import { whatsappTemplatesModule } from '@/app/core/app/whatsapp-templates/whatsapp-templates.module';
import { oauthModule, oauthRoutes } from '@/app/core/oauth/oauth.module';
import {
  BACKOFFICE_LANDING,
  BACKOFFICE_NAV_SECTION,
  backofficeModule,
} from '@/features/backoffice/backoffice.module';
import { label } from '@/platform/app/contracts';
import { coreModules } from '@/platform/app/coreModules';
import { defineApp } from '@/platform/app/defineApp';
import { createTenkoAuthAdapter } from '@/platform/auth/tenkoAuthAdapter';

import { TenkoLogo } from './brand/TenkoLogo';

/** Tenko: AI agents over WhatsApp, channels, catalog and ads reporting. */
export const tenkoApp = defineApp({
  id: 'tenko',
  brand: {
    name: 'Tenko',
    Logo: TenkoLogo,
    termsUrl: 'https://www.tenko.com.co/terms',
    version: 'V1.0.0',
    homeTo: '/app/conversations',
  },
  auth: createTenkoAuthAdapter(),
  onAuthenticated: ({ dispatch, user }) => {
    if (user.organization_id) {
      dispatch(thunkGetOrganization());
    }
  },
  navSections: [
    {
      id: 'main',
      title: label('global', 'sidebar_group_main_label'),
      icon: LayoutDashboard,
      defaultOpen: true,
    },
    // Staff console; empty (so hidden) for customers.
    {
      id: BACKOFFICE_NAV_SECTION,
      title: label('backoffice', 'nav_section_title'),
      icon: ShieldCheck,
      defaultOpen: true,
    },
  ],
  modules: [
    ...coreModules,
    agentsModule,
    productsModule,
    conversationsModule,
    whatsappTemplatesModule,
    whatsappGroupsModule,
    metaAdsModule,
    integrationsModule,
    billingModule,
    apiKeysModule,
    apiUsageModule,
    customDomainsModule,
    oauthModule,
    backofficeModule,
  ],
  routes: { landing: '/app/agents', internalLanding: BACKOFFICE_LANDING },
  topLevelRoutes: oauthRoutes,
  // Pre-split key and version so sessions persisted before the change survive.
  persist: { key: 'root', version: 3 },
});
